import React, {useState} from 'react';

import {PlateMap} from 'samples/plate-maps/PlateMapConstants';
import {ButtonStyle} from 'ui-library/buttons/Button';
import Modal, {ModalButton} from 'ui-library/modals/Modal';

interface PlateTemplate {
  plateMap: PlateMap;
}

export interface CreatePlateTemplateModalProps {
  onRequestClose: () => void;
  onRequestSubmit: (plateTemplate: PlateTemplate) => void;
}

function getModalButtons(plateTemplate: PlateTemplate | null): Array<ModalButton> {
  return [
    {text: 'Cancel', cancel: true},
    {
      text: 'Create plate template',
      submit: true,
      disabled: plateTemplate == null,
      style: ButtonStyle.PRIMARY,
    },
  ];
}

/**
 * Modal with the steps to create a new plate template.
 */
export default function CreatePlateTemplateModal({
  onRequestClose,
  onRequestSubmit,
}: CreatePlateTemplateModalProps): JSX.Element {
  const [plateTemplate, _] = useState<PlateTemplate | null>(null);
  return (
    <Modal
      onRequestClose={onRequestClose}
      onRequestSubmit={() => {
        onRequestSubmit(plateTemplate!);
      }}
      title="Create new plate template"
      buttons={getModalButtons(plateTemplate)}
    >
      TODO: Plate template creation flow
    </Modal>
  );
}
